import { render } from "./B2bPageGenralsReceiveds.vue?vue&type=template&id=275352db&scoped=true&lang=pug"
import script from "./B2bPageGenralsReceiveds.vue?vue&type=script&lang=js"
export * from "./B2bPageGenralsReceiveds.vue?vue&type=script&lang=js"

import "./B2bPageGenralsReceiveds.vue?vue&type=style&index=0&id=275352db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275352db"]])

export default __exports__